var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVimeIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 151.6 122",
    style: {
      enableBackground: "new 0 0 151.6 122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;}\n\t.st2{fill:#030303;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    className: "st0",
    d: "M107.7,122H73.6c-24.3,0-43.9-19.7-43.9-43.9V43.9C29.7,19.7,49.3,0,73.6,0h34.1 c24.3,0,43.9,19.7,43.9,43.9V78C151.6,102.3,131.9,121.9,107.7,122 M73.6,11.3c-18,0-32.6,14.6-32.6,32.6V78 c0,18,14.6,32.6,32.6,32.6h34.1c18,0,32.6-14.6,32.6-32.6V43.9c0-18-14.6-32.6-32.6-32.6L73.6,11.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    x: 29.6,
    className: "st1",
    width: 122,
    height: 122
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    className: "st0",
    d: "M115.5,98H65.8c-6.8,0-12.2-5.5-12.2-12.2v0V36.1c0-6.8,5.5-12.2,12.2-12.2l0,0h49.7 c6.8,0,12.2,5.5,12.2,12.2v49.7C127.7,92.6,122.2,98,115.5,98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    className: "st0",
    d: "M84.5,61c0,23.3-18.9,42.3-42.3,42.3S0,84.3,0,61c0-23.3,18.9-42.3,42.3-42.3 C65.6,18.7,84.5,37.6,84.5,61C84.5,61,84.5,61,84.5,61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    className: "st2",
    d: "M42.3,96.7c-19.7,0-35.7-16-35.7-35.7s16-35.7,35.7-35.7C62,25.2,78,41.2,78,61c0,0,0,0,0,0 C78,80.7,62,96.7,42.3,96.7 M42.3,34.7C27.7,34.7,16,46.5,16,61s11.8,26.3,26.3,26.3S68.5,75.5,68.5,61c0,0,0,0,0,0 C68.5,46.5,56.8,34.7,42.3,34.7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    className: "st1",
    width: 151.6,
    height: 122
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    className: "st1",
    width: 151.6,
    height: 122
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeIconWhite);
export default __webpack_public_path__ + "static/media/VimeIconWhite.e1fa01b987a1f82e42be40c48be3fc4a.svg";
export { ForwardRef as ReactComponent };